import ListView from "./ListView/ListView";

const Employee = {
  ListView,
};

export default Employee;
